import * as React from "react";
import { ToggleButton } from "@mui/lab";
import styled from "styled-components";

const StyledToggleButton = styled(ToggleButton)`
    font-size: 12px;
    font-weight: 300;
    padding: 7px;
    width: 150px;
    text-transform: capitalize;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -6px;
    & > * {
        margin: 6px;
    }
`;

const IndexSubCategoriesToggle = ({
    selectedSubCategory,
    setSelectedSubCategory,
    subcategories,
}) => {
    React.useEffect(() => {
        if (selectedSubCategory === null && subcategories && subcategories.length) {
            setSelectedSubCategory(subcategories[0].id);
        }
    }, [subcategories && JSON.stringify(subcategories)]);

    const handleChange = (newCategory) => {
        if (newCategory !== null) {
            setSelectedSubCategory(newCategory);
        }
    };

    return (
        <ButtonContainer>
            {subcategories.map((category: { id: string; name: string }) => (
                <StyledToggleButton
                    value={category.id}
                    selected={selectedSubCategory === category.id}
                    onClick={() => handleChange(category.id)}
                >
                    {category.name}
                </StyledToggleButton>
            ))}
        </ButtonContainer>
    );
};

export default IndexSubCategoriesToggle;
